<template>
  <section class="section-index-table">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 index-table-col">
          <table class="index-table restriction-table">
            <tr>
              <th class="sort-disabled"><span>Device</span></th>
              <th class="sort-disabled"><span>Command</span></th>
              <th class="sort-disabled"><span>Status</span></th>
              <th class="sort-disabled"><span>User</span></th>
              <th class="sort-disabled"><span>Time</span></th>
            </tr>
            <tr v-for="command in commands">
              <td>{{ command.device }}</td>
              <td>{{ command.command }}</td>
              <td>{{ command.result }}</td>
              <td>{{ command.user }}</td>
              <td>{{ formatDate(command.time) }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import device from "@/api/device";
import moment from "moment";

export default {
  name: "DeviceCommandHistory",
  data() {
    return {
      commands: []
    };
  },
  methods: {
    formatDate(date) {
      return moment.unix(date).format("DD.MM.YY HH:mm");
    },
    load() {
      device
        .commandHistory()
        .then(response => {
          this.commands = response.data;
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  created() {
    this.load();
  }
};
</script>
